import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";

import { ConfigModule } from "#root/config/config.module";
import { StateAccountPaymentsComponent } from "#root/modules/admin/crm/payment-orders/pages/details/components/print-state-account-payments/components/state-account/state-account.component";
import {
  ReceiptDetailComponent,
  ReceiptModalComponent,
  ReceiptModalContent,
  ReceiptModifiedDetailComponent,
} from "#root/modules/admin/crm/payment-orders/pages/details/pages/content/components/payment-order-payment-receipts/dialogs/receipt-modal/receipt-modal.component";
import { LoadingDialogComponent } from "#root/shared/components/loading-dialog/loading-dialog.componente";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSliderModule } from "@angular/material/slider";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MarkdownModule } from "ngx-markdown";
import { BasicObservationDialogComponent } from "./components/basic-observation-dialog/basic-observation-dialog.component";
import { CustomerPepChipComponent } from "./components/customer-pep-chip/customer-pep-chip.component";
import { ImageEditorDialogComponent } from "./components/image-editor-dialog/image-editor-dialog.component";
import { SetCustomerPepDialogComponent } from "./components/customer-pep-chip/set-customer-pep-dialog/set-customer-pep-dialog.component";
import { KpiValueComponent } from "./components/kpi-value/kpi-value.component";
import { LabeledToggleComponent } from "./components/labeled-toggle/labeled-toggle.component";
import { LazyLoadedParentComponent } from "./components/lazy-loaded-parent/lazy-loaded-parent.component";
import { ProductsDialogComponent } from "./components/products-dialog/products-dialog.component";
import {
  ReceiptComponent,
  ReceiptContentComponent,
} from "./components/receipt/receipt.component";
import { UploadFileComponent } from "./components/upload-file/upload-file.component";
import { VersionChangelogComponent } from "./components/version-changelog/version-changelog.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatIconModule,
    MatDialogModule,
    MatDividerModule,
    MatButtonModule,
    MarkdownModule.forChild(),
    MatPaginatorModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSliderModule,
    MatTabsModule,
    MatTooltipModule,
    MatDatepickerModule,
    ConfigModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UploadFileComponent,
    ReceiptDetailComponent,
    ReceiptModalComponent,
    ReceiptModalContent,
    ReceiptContentComponent,
    BasicObservationDialogComponent,
    StateAccountPaymentsComponent,
    LazyLoadedParentComponent,
    KpiValueComponent,
    LabeledToggleComponent,
    CustomerPepChipComponent,
    ImageEditorDialogComponent,
  ],
  declarations: [
    ProductsDialogComponent,
    VersionChangelogComponent,
    ReceiptComponent,
    LoadingDialogComponent,
    UploadFileComponent,
    ReceiptDetailComponent,
    ReceiptModalComponent,
    ReceiptModifiedDetailComponent,
    ReceiptModalContent,
    ReceiptContentComponent,
    BasicObservationDialogComponent,
    StateAccountPaymentsComponent,
    LazyLoadedParentComponent,
    KpiValueComponent,
    LabeledToggleComponent,
    CustomerPepChipComponent,
    SetCustomerPepDialogComponent,
    ImageEditorDialogComponent,
  ],
})
export class SharedModule {}
